import { carrierAPI } from './api';

// Use SDK for jobs (published orders)
export const getAllJobs = carrierAPI.orders.getPublishedOrders;

// Use SDK for best match vehicles
export const getBestVehicleForOrder = carrierAPI.orders.getBestMatchVehicles;

// Use SDK for order update
export const updateOrder = carrierAPI.orders.updateOrder;
